import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import reactBeaconButton from '@trp-beacon-ui-kit/foundation/dist/react/beacon-button';
import reactBeaconModal from '@trp-beacon-ui-kit/foundation/dist/react/beacon-modal';
import reactBeaconError from '@trp-beacon-ui-kit/foundation/dist/react/beacon-error';
import reactBeaconAccordion from '@trp-beacon-ui-kit/foundation/dist/react/beacon-accordion';
import reactBeaconAccordionItem from '@trp-beacon-ui-kit/foundation/dist/react/beacon-accordion-item';
import reactBeaconIcon from '@trp-beacon-ui-kit/foundation/dist/react/beacon-icon';
import reactBeaconControl from '@trp-beacon-ui-kit/foundation/dist/react/beacon-control';
import reactBeaconControlGroup from '@trp-beacon-ui-kit/foundation/dist/react/beacon-control-group'
import reactBeaconIconButton from '@trp-beacon-ui-kit/foundation/dist/react/beacon-icon-button';
import reactBeaconSocialLink from '@trp-beacon-ui-kit/foundation/dist/react/beacon-social-link';
import reactBeaconSocialLinkContainer from '@trp-beacon-ui-kit/foundation/dist/react/beacon-social-link-container';
import reactBeaconNotification from '@trp-beacon-ui-kit/foundation/dist/react/beacon-notification';
import reactBeaconNavigationFooter from '@trp-beacon-ui-kit/foundation/dist/react/beacon-navigation-footer';
import reactBeaconFooter from '@trp-beacon-ui-kit/foundation/dist/react/beacon-footer';
import reactBeaconLoadingSpinner from '@trp-beacon-ui-kit/foundation/dist/react/beacon-loading-spinner';
import reactBeaconTooltip from '@trp-beacon-ui-kit/foundation/dist/react/beacon-tooltip';

// Prefix value to remove conflict with other component
const projectNamePrefix = `ps`;

// Registered Beacon Components

export const PsBeaconAccordion = reactBeaconAccordion(projectNamePrefix);
export const PsBeaconAccordionItem = reactBeaconAccordionItem(projectNamePrefix);
export const PsBeaconButton = reactBeaconButton(projectNamePrefix);
export const PsBeaconControl = reactBeaconControl(projectNamePrefix);
export const PsBeaconControlGroup = reactBeaconControlGroup(projectNamePrefix);
export const PsBeaconError = reactBeaconError(projectNamePrefix);
export const PsBeaconIcon = reactBeaconIcon(projectNamePrefix);
export const PsBeaconModal = reactBeaconModal(projectNamePrefix);
export const PsBeaconIconButton = reactBeaconIconButton(projectNamePrefix);
export const PsBeaconSocialLink = reactBeaconSocialLink(projectNamePrefix);
export const PsBeaconSocialLinkContainer = reactBeaconSocialLinkContainer(projectNamePrefix);
export const PsBeaconNotification = reactBeaconNotification(projectNamePrefix);
export const PsBeaconNavigationFooter = reactBeaconNavigationFooter(projectNamePrefix);
export const PsBeaconFooter = reactBeaconFooter(projectNamePrefix);
export const PsBeaconLoadingSpinner = reactBeaconLoadingSpinner(projectNamePrefix);
export const PsBeaconTooltip = reactBeaconTooltip(projectNamePrefix);


const Registry = {
    PsBeaconIconButton,
    PsBeaconButton,
    PsBeaconModal,
    PsBeaconAccordion,
    PsBeaconAccordionItem,
    PsBeaconControl,
    PsBeaconControlGroup,
    PsBeaconFooter,
    PsBeaconNavigationFooter,
    PsBeaconSocialLinkContainer,
    PsBeaconSocialLink,
    PsBeaconNotification,
    PsBeaconLoadingSpinner,
    PsBeaconTooltip
};

export default Registry;